<template>
  <div>

    <div
      class="modal-dialog modal-small"
      role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">{{ $t('message.getnotificationsvialine') }}</h5>
        </div>
        <div class="modal-header">
          <section>
            <stepprogress-view
              :steps="progress.steps"
              :active="progress.active"
              class="pt-2 stepprogress"
              style="max-width: 100%;margin: auto;"/>
          </section>
        </div>
        <div class="modal-body">
          <section
            v-if="line_step_state == 1"
            class="m-0">
            <div class="col-md-12 no-padding">
              <section-title
                :title="$t('message.connecttoline')"
                fontweight="bold"/>
              <div
                v-if="connect_with_line_error"
                class="row">
                <div class="col-md-12">
                  <div
                    class="alert alert-danger mb-2"
                    role="alert">
                    {{ $t('message.somethingwentwrong') }}
                  </div>
                </div>
              </div>
              <div
                v-if="is_exitst_channel"
                class="row">
                <div class="col-md-12">
                  <div
                    class="alert alert-danger mb-2"
                    role="alert">
                    "{{ this.form.auth.displayname }}"
                    {{ $t('message.hasbeenaddedtothenotificationlist') }}
                  </div>
                </div>
              </div>
              <div
                v-if="!isConnectedLine"
                class="row">
                <div class="col-md-12">
                  <button
                    type="button"
                    class="btn btn-web btn-line"
                    style="with: 100px;"
                    @click="login()">
                    {{ $t('message.loginwithline') }}
                  </button>
                </div>
              </div>
              <div
                v-if="isConnectedLine"
                class="row mt-3">
                <div class="col-md-12 text-center">
                  <img
                    v-if="form.auth.picture"
                    :src="form.auth.picture"
                    width="100"
                    style="border-radius: 100%;">
                  <p class="mt-3">
                    <b>{{ form.auth.displayname }}</b>
                  </p>
                </div>
              </div>
            </div>
            <div class="col-md-12 no-padding mt-3">
              <section-title
                :title="$t('message.getnotititle')"
                fontweight="bold"/>
              <div class="row">
                <div
                  v-for="(value, index) in code"
                  :key="index"
                  class="col-12 mt-2">
                  <vs-checkbox
                    v-model="form.code"
                    :vsValue="value"
                    color="#A3CA76"
                    style="float: left;margin: 0;">
                    {{ $t('notificationcode.' + value) }}
                  </vs-checkbox>
                  <vs-tooltip
                    :text="$t('notificationcodedetail.' + value)"
                    position="top"
                    style="float: left;margin-left: 5px;">
                    <i class="fas fa-info-circle"/>
                  </vs-tooltip>
                </div>
              </div>
            </div>
          </section>
          <section
            v-if="line_step_state == 2"
            class="m-0">
            <div class="col-md-12 no-padding text-center">
              <p>
                <img
                  src="@/assets/images/qrcode/treesoft.png"
                  width="150">
              </p>
              <p class="mb-0">
                {{ $t('message.scanqrcodeoraddwithlineid') }}
              </p>
              <div>
                <div style="float: left;width: 466px;margin-top: 13px;">
                  <div
                    class=""
                    style="position: relative; float: left; width: 95px; left: 185.5px;">
                    <iframe
                      :src="'https://social-plugins.line.me/widget/friend?lineId=%40treesoft&lang='+$store.state.app.lang+'&type=friend&id=0&origin=https%3A%2F%2Fwww.treesoft.io%2Fline.html&title='"
                      style="width: 95px;height: 20px;visibility: visible;position: static !important;opacity: 1 !important;border: none;"
                    />
                  </div>
                </div>
              </div>
            </div>
          </section>
          <section
            v-if="line_step_state == 3"
            class="m-0">
            <div class="col-md-12 no-padding text-center">
              <p class="m-0">
                {{ $t('message.addednotificationreceivedsuccessfully') }}
              </p>
            </div>
          </section>
        </div>
        <div
          class="modal-footer row m-0 pr-0"
          style="justify-content: normal;display: -webkit-box;">
          <div class="row col-12 pr-0 d-flex align-items-center">
            <div class="col-4 p-0 text-left">
              <a
                :href="learnmoreLink"
                target="_blank"
              >
                {{ $t('button.learnmore') }}
                <i class="fas fa-external-link-alt"/>
              </a>
            </div>
            <div class="col-8 p-0 text-right">
              <template v-if="line_step_state == 1">
                <button
                  v-if="$store.state.app.loading"
                  :disabled="true"
                  type="button"
                  class="btn btn-light"
                  @click="toStep2()">
                  <i class="fas fa-spinner spin"/>
                </button>
                <button
                  v-else
                  :disabled="!isConnectedLine || !isSelectedNoti"
                  type="button"
                  class="btn btn-light"
                  @click="toStep2()">
                  {{ $t('button.next') }}
                </button>
              </template>
              <button
                v-if="line_step_state == 2"
                type="button"
                class="btn btn-light"
                @click="toStep3()">
                {{ $t('button.addedfriend') }}
                ({{ $t('button.next') }})
              </button>
              <button
                v-if="line_step_state == 3"
                type="button"
                class="btn btn-web"
                @click="done()">
                {{ $t('button.done') }}
              </button>
              <button
                v-if="line_step_state == 1"
                :disabled="$store.state.app.loading"
                type="button"
                class="btn btn-light"
                @click="closed()">
                {{ $t('button.close') }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import stepprogressView from '@/components/custom/StepProgress.vue'
import project from '@/project'
const jwt = require('jsonwebtoken')

export default {
  components: {
    stepprogressView,
  },
  props: {
    app_id: {
      type: Number,
    },
    code: {
      type: Array,
    },
  },
  data () {
    return {
      line_step_state: 1,
      progress: {
        steps: [
          this.$t('message.getlinenotiprogress1'),
          this.$t('message.getlinenotiprogress2'),
          this.$t('message.getlinenotiprogress3'),
        ],
        active: 0,
      },
      form: {
        auth: {
          displayname: null,
          line_id: null,
          picture: null,
        },
        code: [],
      },
      connect_with_line_error: false,
      is_exitst_channel: false,
    }
  },
  computed: {
    isConnectedLine () {
      return this.form.auth.line_id !== null
    },
    isSelectedNoti () {
      return this.form.code.length != 0
    },
    learnmoreLink () {
      switch (this.app_id) {
        case 1:
          return 'https://www.treesoft.io/th/manual/pos#setting'
          break
        case 3:
          return 'https://www.treesoft.io/th/manual/inventory#setting'
          break
      }
      return null
    },
  },
  methods: {
    login () {
      // reset
      this.connect_with_line_error = false
      this.is_exitst_channel = false
      // set opts and login
      this.loginLine({ app_id: this.app_id }, this.handleLoginLine)
    },
    handleLoginLine (err, res) {
      if (err) {
        this.connect_with_line_error = true
        return
      }

      // get value from token
      const decoded = jwt.verify(res.token, project.config.token.secret)

      // set auth
      this.form.auth.displayname = decoded.displayname
      this.form.auth.line_id = decoded.line_id
      this.form.auth.picture = decoded.picture
    },
    reset () {
      this.line_step_state = 1
      this.progress.active = 0
      this.form.auth.displayname = null
      this.form.auth.line_id = null
      this.form.auth.picture = null
      this.form.code = []
      this.connect_with_line_error = false
      this.is_exitst_channel = false
    },
    closed () {
      this.reset()
      this.$emit('closed')
    },
    async done () {
      this.reset()
      this.$emit('done')
    },
    async saveChannelNoti () {
      let dataSet = {
        'app_id': this.app_id,
      	'code': this.form.code,
      	'channel': 'line',
      	'passport': this.form.auth.line_id,
      }

      let res = await this.$store.dispatch('insertChannelNoti', dataSet)

      // loading finish
      this.showFinish(this.$Progress)

      // this line account is already exists in database or not
      return res.success
    },
    async toStep2 () {
      let success = await this.saveChannelNoti()

      if (!success) {
        this.is_exitst_channel = true
        return
      }

      this.line_step_state = 2
      this.progress.active = 1
    },
    toStep3 () {
      this.line_step_state = 3
      this.progress.active = 3
    },
  },
}
</script>

<style scoped>
  .btn-web {
    position: relative;
  }
  .btn-web i.fa-line {
    position: absolute;
    top: 7px;
    left: 7px;
    font-size: 18px;
  }
  .btn-web i.fa-envelope {
    position: absolute;
    top: 9px;
    left: 8px;
    font-size: 17px;
  }
  .stepprogress {
    position: relative;
    z-index: 1;
  }
</style>



// WEBPACK FOOTER //
// src/components/custom/modal/channelnoti/AddLine.vue